module.exports = __webpack_public_path__ + "img/maintenance-horses.4ed4ed8b.jpg";